<div class="layout">
  <ix-certificate-list
    #certificateList
    (certificateDeleted)="authorityList.dataProvider.load()"
  ></ix-certificate-list>

  <ix-csr-list></ix-csr-list>

  <ix-certificate-authority-list
    #authorityList
    (certificateSigned)="certificateList.dataProvider.load()"
  ></ix-certificate-authority-list>

  <ix-acme-dns-authenticator-list></ix-acme-dns-authenticator-list>
</div>
